import React from "react";
import {
  Box,
  Stepper,
  Step as StepperItem,
  StepLabel as StepperItemLabel,
} from "@material-ui/core";
import { Type } from "./type";
import { Summary } from "./summary";
import messages from "./messages.json";
import { useRequestContext } from "../context";
import { SystemDetails } from "./system-details";
import { UserInformation } from "./user-information";

const MESSAGES = (messages as unknown) as Record<
  string,
  Record<string, Record<string, string>>
>;

export const Steps: React.FC = () => {
  const [requestContextState, requestContextDispatch] = useRequestContext();

  // Effects

  React.useEffect(() => {
    const { name, view } = requestContextState.step;

    requestContextDispatch({
      type: "set-message",
      message: MESSAGES[name][view]["root"],
    });
  }, [requestContextState.step, requestContextDispatch]);

  // Helpers

  function isUserInformationStepCompleted(): boolean {
    return (
      requestContextState.step.name === "system-details" ||
      requestContextState.step.name === "summary"
    );
  }

  function isUserInformationStepActive(): boolean {
    return requestContextState.step.name === "user-information";
  }

  function isSystemDetailsStepCompleted(): boolean {
    return requestContextState.step.name === "summary";
  }

  function isSystemDetailsStepActive(): boolean {
    return requestContextState.step.name === "system-details";
  }

  function isSummaryStepCompleted(): boolean {
    return false;
  }

  function isSummaryStepActive(): boolean {
    return requestContextState.step.name === "summary";
  }

  function isTypeActive(): boolean {
    const { name, view } = requestContextState.step;
    return name === "type" && view === "select-type";
  }

  let type = isTypeActive() ? <Type /> : null;
  let userInformation = isUserInformationStepActive() ? (
    <UserInformation />
  ) : null;
  let systemDetails = isSystemDetailsStepActive() ? <SystemDetails /> : null;
  let summary = isSummaryStepActive() ? <Summary /> : null;

  return (
    <Box height="100%" display="flex" flexDirection="column">
      {requestContextState.step.name !== "type" ? (
        <Stepper>
          <StepperItem
            completed={isUserInformationStepCompleted()}
            active={isUserInformationStepActive()}
          >
            <StepperItemLabel>User Information</StepperItemLabel>
          </StepperItem>
          <StepperItem
            completed={isSystemDetailsStepCompleted()}
            active={isSystemDetailsStepActive()}
          >
            <StepperItemLabel>System Details</StepperItemLabel>
          </StepperItem>
          <StepperItem
            completed={isSummaryStepCompleted()}
            active={isSummaryStepActive()}
          >
            <StepperItemLabel>Summary</StepperItemLabel>
          </StepperItem>
        </Stepper>
      ) : null}

      {type}
      {userInformation}
      {systemDetails}
      {summary}
    </Box>
  );
};
